import { Megaphone, Rocket, Sparkles } from "lucide-react";
import { Reveal, SplitLines } from "./motion";

const WHO = [
  { icon: Megaphone, n: "01", who: "Gestores de tráfego e agências", text: "Publicar a página do cliente hoje, não semana que vem. Pastas por cliente, colaboração e domínios próprios." },
  { icon: Rocket, n: "02", who: "Infoprodutores, afiliados e lançadores", text: "Vendas, captura e low ticket no ar em minutos pra testar oferta antes do concorrente." },
  { icon: Sparkles, n: "03", who: "Quem gera páginas com IA", text: "Você sabe pedir a página perfeita pro ChatGPT ou Claude. Não precisa saber (nem querer) lidar com código, hospedagem e DNS." },
];

export const Audience = () => (
  <section id="para-quem" data-testid="audience-section" className="relative py-28 sm:py-36 px-6">
    <div className="mx-auto max-w-7xl">
      <Reveal y={16} className="eyebrow mb-8">Para quem é</Reveal>
      <SplitLines as="h2" inView className="font-display font-bold tracking-[-0.03em] leading-[1] text-4xl sm:text-5xl lg:text-6xl text-[var(--ink)] max-w-3xl" lines={["Feito pra quem tem", "pressa de vender."]} />
      <div className="mt-16 grid md:grid-cols-3 gap-px bg-slate-200 rounded-3xl overflow-hidden border border-slate-200">
        {WHO.map((w, i) => (
          <Reveal key={w.n} delay={i * 0.12} data-testid={`audience-card-${i + 1}`} className="group bg-[var(--bg)] hover:bg-white p-8 sm:p-10 transition-colors duration-500 relative">
            <div className="flex items-center justify-between">
              <span className="h-12 w-12 rounded-2xl bg-white border border-slate-200 grid place-items-center text-[var(--ink)] group-hover:bg-[var(--blue)] group-hover:text-white group-hover:border-[var(--blue)] transition-colors duration-500"><w.icon size={20} /></span>
              <span className="font-mono text-sm text-slate-400">{w.n}</span>
            </div>
            <h3 className="mt-10 font-display font-semibold text-2xl tracking-tight text-[var(--ink)]">{w.who}</h3>
            <p className="mt-4 text-slate-600 leading-relaxed">{w.text}</p>
            <span className="absolute bottom-0 left-0 h-1 w-0 bg-[var(--orange)] group-hover:w-full transition-all duration-700" />
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
